import WebSocketRequest from './web-socket-request';
import { normalizePusherMessageData } from '../services/pusher-service/normalize-pusher-message';

const SingleOneToManyWebSocketRequest = ({ callApi, eventNames, selectRequestGuids, checkForFinalMessage, storeGuids }) => {
  const buildOnMessage = (observer, guids, messages, unsub) => (message) => {
    const normalizedMessage = { ...message, data: normalizePusherMessageData(message.data) };
    const isFinal = checkForFinalMessage(normalizedMessage);

    if (!guids.length && storeGuids.length) {
      storeGuids.map((store) => {
        if (store.storeGuid === normalizedMessage.data.StoreGUID) {
          messages.push(normalizedMessage);
        }
        return messages;
      });
    }

    if (isFinal) {
      unsub();
      observer.next(messages);
      observer.complete();
    }
  };

  return WebSocketRequest({
    callApi,
    eventNames,
    buildOnMessage,
    selectRequestGuids,
  });
};

export default SingleOneToManyWebSocketRequest;
